export class UrlUtils {
  /**
   * Générer une fonction de formattage d'url plus propre que de faire de la concaténation de chaîne à la main,
   * notamment pour passer des paramètres de type chaîne.
   * Exemple d'utilisation:
   * let getUrl = UrlUtils.generateActionUrlFormatter(`${this.configService.config.urlApi}/f/api/sessions`);
   *
   * http.get(getUrl('getById', {id: 5})
   *
   */
  static generateActionUrlFormatter(baseUrl: string) {
    return (action: string = null, parameters: {[key: string]: any} | string[] = null) => {
      let paramString = '';
      if (parameters != null) {
        if (parameters instanceof Array) {
           paramString = '/' + parameters.join('/')
        } else {
          paramString =
            '?' +
            Object.keys(parameters)
              .map(key => `${key}=${parameters[key]}`)
              .join('&');
          paramString = paramString || '';
        }
      }
      const actionPart = (action == null || action == '') ? '' : `/${action}`;
      return `${baseUrl}${actionPart}` + paramString;
    };
  }
}
